import React, { useMemo } from "react";
import {
  Card,
  Descriptions,
  Tag,
  Spin,
  Empty,
  Typography,
  Collapse,
} from "antd";
import { useTranslation } from "react-i18next";

const { Text } = Typography;

export function StepReview({
  loading,
  therapyDetail,
  selectedPatientIds,
  patients,
}) {
  const { t } = useTranslation("therapy");

  const selectedPatients = useMemo(() => {
    const map = new Map((patients || []).map((p) => [p._id, p]));
    return selectedPatientIds.map((id) => map.get(id)).filter(Boolean);
  }, [patients, selectedPatientIds]);

  if (loading) {
    return (
      <div
        style={{
          height: 320,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  if (!therapyDetail)
    return <Empty description={t("wizard.revision.errorDetalle")} />;

  const collapseItems = (therapyDetail.scenes || []).map((s, idx) => ({
    key: String(idx),
    // La escena viene de la base de datos; el rotulo, el numero y el guion
    // son interfaz. El respaldo cuando la escena no tiene titulo tambien.
    label: t("wizard.revision.etiquetaSala", {
      numero: idx + 1,
      escena:
        s?.virtualScene?.module_01?.ModOneTitle ||
        t("wizard.revision.salaSinTitulo"),
    }),
    children: (
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        {(s?.evaluations || []).length ? (
          s.evaluations.map((ev) => <Tag key={ev._id}>{ev.title}</Tag>)
        ) : (
          <Text type="secondary">{t("wizard.revision.sinEvaluaciones")}</Text>
        )}
      </div>
    ),
  }));

  return (
    <div className="revi-wizard-review">
      <Card variant="outlined" className="revi-wizard-review__card">
        <Descriptions column={1} bordered size="small">
          <Descriptions.Item label={t("wizard.revision.terapia")}>
            {therapyDetail.title}
          </Descriptions.Item>
          <Descriptions.Item label={t("wizard.revision.usuarios")}>
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
              {selectedPatients.length ? (
                selectedPatients.map((p) => (
                  <Tag key={p._id}>
                    {p.name} {p.surname}
                  </Tag>
                ))
              ) : (
                <Text type="secondary">—</Text>
              )}
            </div>
          </Descriptions.Item>
          <Descriptions.Item label={t("wizard.revision.salas")}>
            {Array.isArray(therapyDetail.scenes)
              ? therapyDetail.scenes.length
              : 0}
          </Descriptions.Item>
        </Descriptions>
      </Card>

      <Card
        variant="outlined"
        className="revi-wizard-review__card"
        style={{ marginTop: 14 }}
      >
        <Text strong>{t("wizard.revision.flujo")}</Text>
        <div style={{ marginTop: 10 }}>
          <Collapse items={collapseItems} />
        </div>
      </Card>
    </div>
  );
}
